<template>
    <div class="mb-2">
        <div class="card shadow-sm">
            <div class="card-body p-2">
                <div class="d-flex align-items-center justify-content-between">
                    <div class="">
                        <h6 class="mb-1">To Study Coding</h6>
                        <small>Feb 15 3:02 PM</small>
                    </div>
                    <div class="">
                        <button class="btn btn-sm btn-outline-danger me-2">
                            <i class="bi-trash"></i>
                        </button>
                        <button class="btn btn-sm btn-outline-warning">
                            <i class="bi-pencil"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {deleteUser, useLoadUsers} from "../firebase";

    export default {
        name: "UserList",
        setup() {
            let i = 1;
            const users = useLoadUsers()

            return { users, deleteUser, i}
        }
    }
</script>

<style scoped>

</style>